/**
 * Mark Top 4 As Highly Recommended AB Test group variable
 */
export const MARK_TOP4_AS_HIGHLY_RECOMMENDED_AB_TEST_GROUP = {
  ORIGINAL: 'ORIGINAL',
  TEST: 'TEST',
  FAILED: 'FAILED',
} as const;

export const JOB_DETAIL_TOP4_AS_HIGHLY_RECOMMENDED_AB_TEST_GROUP = {
  ORIGINAL: 'ORIGINAL',
  TEST1: 'TEST1',
  TEST2: 'TEST2',
  FAILED: 'FAILED',
} as const;
